import { I18nType } from '@/ui/types/i18n.types';

type CheckFn = (value: string) => Promise<boolean>;
type I18nFormattedTextType = {
  property: string;
  module: string;
  submodule: string;
};

export default function useAsyncValidation(i18n: I18nType) {
  return async (i18nParameters: I18nFormattedTextType, checkFn: CheckFn, v: string) => {
    if (!v) {
      return true;
    }

    const isValid = await checkFn(v);

    const { property, module, submodule } = i18nParameters;

    if (!isValid) {
      return i18n.getFormattedText(module, submodule, property, { property });
    }

    return true;
  };
}
